import app from 'flarum/forum/app';
import EventPost from 'flarum/forum/components/EventPost';
import currencySymbol from '../../common/currencySymbol';

export default class BountyAddedEventPost extends EventPost {
  icon() {
    return 'fas fa-hand-holding-heart';
  }

  description(data: Record<string, string>) {
    return <span>{app.translator.trans('blomstra-payments.forum.post_stream.bounty_added_text', data)}</span>;
  }

  descriptionData() {
    const post = this.attrs.post;
    const amount: number = (post.content() as unknown as Record<string, number>).amount / 100;
    const currency: string = (post.content() as unknown as Record<string, string>).currency;

    return {
      amount: (
        <strong className="BountyAddedEventPost-amount">
          {currencySymbol(currency)} {amount}
        </strong>
      ),
    };
  }
}
